import { render, staticRenderFns } from "./psyhelp.vue?vue&type=template&id=553c2149&scoped=true&"
import script from "./psyhelp.vue?vue&type=script&lang=js&"
export * from "./psyhelp.vue?vue&type=script&lang=js&"
import style0 from "./psyhelp.vue?vue&type=style&index=0&id=553c2149&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553c2149",
  null
  
)

export default component.exports